<template>
    <div>

        <el-container>
            <el-header height="auto"><common-header /></el-header>
            <el-container class="page-content">
                <el-aside width="auto">
                    <common-asideVue />
                </el-aside>
                <el-main class="el-main">
                    <updateziliao-right />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import ElContainer from "element-ui/packages/container/src/main";
    import CommonAsideVue from '@/components/CommonAside.vue'
    import CommonHeader from '@/components/CommonHeader.vue'
    import UpdateziliaoRight from "../components/UpdateziliaoRight";
    export default {
        components: {
            UpdateziliaoRight,
            ElContainer,CommonHeader,CommonAsideVue},
        name: "updateziliao",
        data () {
            return {}
        },
        methods: {

        }
    }
</script>

<style scoped>
    .el-header{
        padding:0;
    }
</style>